import { List } from "@mui/material";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { getIsShowModuleSidebar } from "../../../application/selectors/ui";
import { getUserMenuList } from "../../../application/selectors/user";
import { setIsShowModuleSideBar } from "../../../application/slices/ui";
import {
  canAccessDistributionPortal,
  canManageContractorTeam,
  canManageDistributionTeam,
  isContractorUser,
} from "../../utils/authRoleHelpers";
import { menuMatchesPathSegment } from "../../pages/SLN/shared/projectWorkspace/projectWorkspaceMenu";
import {
  buildContractorModuleMenuItems,
  isContractorAreaPath,
} from "../../pages/SLN/contractor/contractorMemberNav";
import {
  buildDistributionModuleMenuItems,
  isDistributionCompanyAreaPath,
} from "../../pages/EDC/edcNav";
import MenuItem from "./MenuItem";

const ModuleSideBar = ({ isShowMainMenu }) => {
  const menuList = useSelector(getUserMenuList);
  const isShowModuleSideBar = useSelector(getIsShowModuleSidebar);

  const dispatch = useDispatch();
  const location = useLocation();
  const [open] = useState(true);
  const [subMenu, setSubMenu] = useState([]);

  useEffect(() => {
    const pathnames = location.pathname.split("/").filter((x) => x);

    if (isContractorAreaPath(location.pathname) && isContractorUser()) {
      const segments = pathnames.slice(0, 2);
      const specificNode =
        Array.isArray(menuList) && pathnames.length >= 2
          ? onFindSpecificNode(segments, { child: menuList })
          : null;
      const umChildren =
        specificNode &&
        menuMatchesPathSegment(specificNode, segments[1] || "Contractor") &&
        Array.isArray(specificNode.child)
          ? specificNode.child
          : [];

      dispatch(setIsShowModuleSideBar(true));
      setSubMenu(
        umChildren.length > 0
          ? umChildren
          : buildContractorModuleMenuItems({
              canManageTeam: canManageContractorTeam(),
            })
      );
      return;
    }

    if (
      isDistributionCompanyAreaPath(location.pathname) &&
      canAccessDistributionPortal()
    ) {
      const segments = pathnames.slice(0, 2);
      const specificNode =
        Array.isArray(menuList) && pathnames.length >= 2
          ? onFindSpecificNode(segments, { child: menuList })
          : null;
      const umChildren =
        specificNode &&
        menuMatchesPathSegment(specificNode, segments[1] || "EDC") &&
        Array.isArray(specificNode.child)
          ? specificNode.child
          : [];

      dispatch(setIsShowModuleSideBar(true));
      setSubMenu(
        umChildren.length > 0
          ? umChildren
          : buildDistributionModuleMenuItems({
              pathname: location.pathname,
              canManageTeam: canManageDistributionTeam(),
            })
      );
      return;
    }

    if (pathnames.length >= 2 && Array.isArray(menuList)) {
      if (
        pathnames.find((x) => x === "dashboard") ||
        location.pathname === "/account/resetpassword"
      ) {
        dispatch(setIsShowModuleSideBar(false));
      } else {
        dispatch(setIsShowModuleSideBar(true));

        const segments = pathnames.slice(0, 2);
        const specificNode = onFindSpecificNode(segments, {
          child: menuList,
        });
        const lastSegment = segments[1];
        const nodeMatchesPath =
          !lastSegment ||
          (specificNode && menuMatchesPathSegment(specificNode, lastSegment));
        setSubMenu(
          nodeMatchesPath && Array.isArray(specificNode?.child)
            ? specificNode.child
            : []
        );
      }
    } else {
      dispatch(setIsShowModuleSideBar(false));
    }
  }, [dispatch, location, menuList]);

  const onFindSpecificNode = (pathnames, menuListArg) => {
    let specificNode = menuListArg;

    pathnames.forEach((path) => {
      const item = specificNode.child?.find((menu) =>
        menuMatchesPathSegment(menu, path)
      );

      if (item) {
        specificNode = item;
      }
    });

    return specificNode;
  };

  return isShowModuleSideBar ? (
    <div
      className={clsx({
        "module-sidebar-container": true,
        "hide-main-menu": !isShowMainMenu,
        hide: !isShowModuleSideBar,
      })}
    >
      <List>
        {React.Children.toArray(
          subMenu.map((item) => (
            <MenuItem
              key={item.id}
              menu={item}
              isOpenedSideBar={open}
              setIsOpenedSideBar={() => {}}
            />
          ))
        )}
      </List>
    </div>
  ) : null;
};

export default ModuleSideBar;
